import { NavLink } from "react-router-dom";




const Navbar = () => {
  
  return (
    <>
      <div className="navbar text-white font-bold  fixed top-0 text-xl py-4 px-10 z-50">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex="0" className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex="0"
              className="menu menu-compact dropdown-content mt-3 p-2 shadow text-white font-bold rounded-box"
            >
              <li className="hover:text-pink-700">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/about">About</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/portfolio">Portfolio</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/blog">Blog</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/contact">Contact</NavLink>
              </li>
            </ul>
          </div>
          <a href="#home" className="btn btn-ghost normal-case text-2xl hover:text-pink-700">
            Alamin Sarker
          </a>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal p-0 font-bold">
          <li className="hover:text-pink-700">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/about">About</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/portfolio">Portfolio</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/blog">Blog</NavLink>
              </li>
              <li className="hover:text-pink-700">
                <NavLink to="/contact">Contact</NavLink>
              </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
